import { useMemo } from "react";
import type { Document } from "../types";
import { usePodcasts } from "./usePodcasts";
import { useSavedPodcastsCache } from "./useSavedPodcastsCache";

export const useSavedPodcasts = () => {
	const { podcasts, isLoading } = usePodcasts();

	const { isPodcastSaved, toggleSavedPodcast } = useSavedPodcastsCache();

	const savedPodcasts = useMemo(() => {
		return podcasts.filter((podcast) => isPodcastSaved(podcast.id));
	}, [podcasts, isPodcastSaved]);

	// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
	const savedPodcastsByType = useMemo(() => {
		const grouped = new Map<string, Document[]>();

		for (const podcast of savedPodcasts) {
			const topics = podcast.metadata.topics;
			if (Array.isArray(topics) && topics.length > 0) {
				for (const topic of topics) {
					if (!grouped.has(topic)) {
						grouped.set(topic, []);
					}
					grouped.get(topic)!.push(podcast);
				}
			} else {
				if (!grouped.has("Uncategorized")) {
					grouped.set("Uncategorized", []);
				}
				grouped.get("Uncategorized")!.push(podcast);
			}
		}

		return Array.from(grouped).map(([topic, podcasts]) => ({
			type: topic,
			podcasts,
		}));
	}, [savedPodcasts]);

	return {
		savedPodcasts,
		savedPodcastsByType,
		isPodcastSaved,
		toggleSavedPodcast,
		isLoading,
	};
};
